<div id="toolbar" class="clr-row nxm clr-justify-content-between clr-align-items-end">
  <div class="clr-col-auto margin-12-tb">
    <div class="btn-group btn-primary btn-icon">
      <button
        class="btn btn-outline"
        style="min-width: 42px"
        (click)="newProject()"
        [disabled]="authService.token.rights.status <= 2">
        <clr-tooltip>
          <cds-icon clrTooltipTrigger shape="file" />
          <clr-tooltip-content [clrPosition]="'bottom-right'" [clrSize]="'md'">
            {{ 'Neues Projekt' | mrTranslate }}
          </clr-tooltip-content>
        </clr-tooltip>
      </button>
      <button
        class="btn btn-outline"
        style="min-width: 42px"
        (click)="newSubProject()"
        [disabled]="authService.token.rights.status <= 2 || !selected()">
        <clr-tooltip>
          <cds-icon clrTooltipTrigger shape="file-group" />
          <clr-tooltip-content [clrPosition]="'bottom-right'" [clrSize]="'md'">
            {{ 'Neuer Teilabschnitt zu Projekt' | mrTranslate }}
          </clr-tooltip-content>
        </clr-tooltip>
      </button>
      <button
        class="btn btn-outline"
        style="min-width: 42px"
        (click)="openProject()"
        [disabled]="authService.token.rights.status <= 2 || !selected()">
        <clr-tooltip>
          <cds-icon clrTooltipTrigger shape="folder-open" />
          <clr-tooltip-content [clrPosition]="'bottom-right'" [clrSize]="'md'">
            {{ 'Projekt öffnen' | mrTranslate }}
          </clr-tooltip-content>
        </clr-tooltip>
      </button>
      <button
        class="btn btn-outline"
        style="min-width: 42px"
        (click)="deleteProject()"
        [disabled]="authService.token.rights.status <= 2 || !selected()">
        <clr-tooltip>
          <cds-icon clrTooltipTrigger shape="delete" />
          <clr-tooltip-content [clrPosition]="'bottom-right'" [clrSize]="'md'">
            {{ 'Projekt löschen' | mrTranslate }}
          </clr-tooltip-content>
        </clr-tooltip>
      </button>
      <button class="btn btn-outline" style="min-width: 42px" (click)="capture()">
        <clr-tooltip>
          <cds-icon clrTooltipTrigger shape="camera" />
          <clr-tooltip-content [clrPosition]="'bottom-right'" [clrSize]="'md'">
            {{ 'Gantt-Chart Drucken' | mrTranslate }}
          </clr-tooltip-content>
        </clr-tooltip>
      </button>

      <clr-select-container class="clr-col-auto" style="flex-direction: row; margin-top: 8px">
        <label>{{ 'Jahr' | titlecase | mrTranslate }}</label>
        <select clrSelect [(ngModel)]="sel" (change)="selYearChanged(sel)">
          @for (obj of years; track obj) {
            <option [ngValue]="+obj">
              {{ obj }}
            </option>
          }
        </select>
        <clr-control-error *clrIfError="'required'">
          {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
        </clr-control-error>
      </clr-select-container>
    </div>
  </div>
</div>

<div class="clr-row">
  <div style="margin-left: 20px; max-width: 98vw; height: 85vh" id="gantt"></div>
</div>
